import CustomStore from 'devextreme/data/custom_store'
import { axiosInstance } from '@/http-common'
import { AxiosResponse } from 'axios'
import jQuery from 'jquery'

const $ = jQuery

const store = new CustomStore({
    cacheRawData: false,
    key: 'imei',
    load: () => {
        const d = $.Deferred()
        axiosInstance.get(`/api/v1/tacho/reminders/vehicles`)
            .then((response: AxiosResponse) => {
                d.resolve({ data: response.data, totalCount: null })
            })
            .catch(() => {
                d.resolve({ data: [], totalCount: null })
            })
        return d.promise()
    }
})

export function getStore(): CustomStore {
    return store
}